import * as React from 'react'
import styled from 'styled-components'
import { createPortal } from 'react-dom'

import { t, tc } from '@owl-nest/localize'
import * as plume from '@ulule/owl-kit-components/next'

type SecurePaymentModalProps = {
  className?: string
  open: boolean
  projectIsDonationBased: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
}

function SecurePaymentModalComponent({
  className,
  open,
  projectIsDonationBased,
  setOpen,
}: SecurePaymentModalProps): React.ReactElement {
  return (
    <>
      {createPortal(
        <plume.ModalWithIcon
          className={className}
          open={open}
          closable
          onClose={() => setOpen(false)}
          icon={<plume.illustrations.twoToned.SecurePaymentMedium size={140} />}
          svgScale={0.9}
          buttons={{
            type: 'button',
            props: {
              onClick: () => setOpen(false),
              size: 'medium',
              children: t('Continue'),
            },
          }}
        >
          <plume.styles.heading.S>
            {projectIsDonationBased ? t('Secure and final payment') : t('Secure and flexible payment')}
          </plume.styles.heading.S>
          <plume.styles.copy.M.light>
            {projectIsDonationBased
              ? t(
                  'Your payment in the form of a donation is not refundable. However, if the project team decides to cancel its fundraising, you will automatically get a refund.',
                )
              : t(
                  "If the project doesn't reach its goal, you will be refunded free of charge to your bank account or the payment method used.",
                )}
          </plume.styles.copy.M.light>
          <plume.styles.copy.M.light>
            {t('All payments are secure, and we do not store any credit card information.')}
          </plume.styles.copy.M.light>
          <plume.styles.copy.M.light>
            {tc('For more information about Ulule, [link: see FAQ].', {
              link: (
                <plume.styles.link.Primary tinted href="https://support.ulule.com/hc/" target="_blank" rel="noopener" />
              ),
            })}
          </plume.styles.copy.M.light>
          <PaymentPartnersLogoSection>
            <plume.glyphs.paymentMethods.SSL></plume.glyphs.paymentMethods.SSL>
            <plume.glyphs.paymentMethods.VerifiedByVisa></plume.glyphs.paymentMethods.VerifiedByVisa>
            <plume.glyphs.paymentMethods.MastercardSecurecode></plume.glyphs.paymentMethods.MastercardSecurecode>
          </PaymentPartnersLogoSection>
        </plume.ModalWithIcon>,
        document.getElementById('modal-container') ?? document.body,
      )}
    </>
  )
}

export const SecurePaymentModal = styled(SecurePaymentModalComponent)`
  ${plume.styles.modal.Body} {
    display: flex;
    flex-direction: column;
  }

  ${plume.styles.heading.S} {
    text-align: left;
    margin: 15px 0;
  }

  ${plume.styles.copy.M.light} {
    text-align: left;
    margin-bottom: 25px;
  }

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    ${plume.styles.modal.Wrapper} {
      max-width: 480px;
    }
  }
`

const PaymentPartnersLogoSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  margin: 0 auto;
  margin-bottom: 13px;
  width: 60%;

  svg {
    height: 1.8rem;
    margin-bottom: 10px;
    width: 25%;
  }
`
